import React, { useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import LayoutDashboard from "../../Components/Layout/LayoutDashboard";
import Spinner from "../../Complements/Spinner";
import MaterialTable from "material-table";
import {
  Grid,
  Typography,
  Fab,
  Tooltip,
  Hidden,
  IconButton,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import { Add as AddIcon, Edit as EditIcon } from "@material-ui/icons";
import BillingAddressContext from "../../Reducers/BillingAddress/BillingAddressContext";

const useStyles = makeStyles((theme) => ({
  fabGreen: {
    color: theme.palette.common.white,
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[600],
    },
  },
  container: {
    padding: theme.spacing(4, 11, 4, 2),
  },
  titleBar: {
    background: "linear-gradient(50deg, #3f51b5 33%, indigo 100%)",
    color: "white",
    borderRadius: 15,
    margin: "100px 25px 20px",
    padding: "10px 20px",
  },
}));

const Index = () => {
  const classes = useStyles();
  const { GetBillingAddresses, billingAddress, loading } = useContext(
    BillingAddressContext
  );

  useEffect(() => {
    GetBillingAddresses();
  }, []);

  if (loading) return <Spinner />;

  return (
    <LayoutDashboard>
      <Grid container>
        <Grid item xs={12} className={classes.titleBar}>
          <Typography variant="h4">Direcciones de Facturación</Typography>
        </Grid>

        <Grid item xs={12} align="right" style={{ margin: "-30px 30px 10px" }}>
          <Fab
            className={classes.fabGreen}
            aria-label="add"
            href="/CrearDirecciónesFacturación"
          >
            <Tooltip title="Agregar Direccion de Facturación">
              <AddIcon />
            </Tooltip>
          </Fab>
        </Grid>
      </Grid>

      <Hidden smDown>
        <Grid item xs={12} style={{ margin: "10px 30px" }}>
          <MaterialTable
            title=""
            columns={[
              { title: "ID", field: "id" },
              { title: "Nombre", field: "name" },
              { title: "RFC", field: "rfc" },
              { title: "Pais", field: "country" },
              { title: "Estado", field: "state.name" },
              { title: "Municipio", field: "municipality.name" },
              { title: "C.P", field: "postal_code" },
              { title: "Calle", field: "address" },
              { title: "No.Exterior", field: "no_ext" },
              { title: "CFDI", field: "cfdi" },
              {
                title: "Cliente",
                field: "client",
                render: (rowData) =>
                  `${rowData.client?.name || ""} ${
                    rowData.client?.first_lastname || ""
                  } ${rowData.client?.second_lastname || ""}`.trim(),
              },
            ]}
            data={billingAddress}
            options={{ actionsColumnIndex: -1 }}
            actions={[{ icon: "delete", tooltip: "Eliminar Usuario" }]}
            components={{
              Action: ({ data }) => (
                <Link to={`EditarDirecciónesFacturación/${data.id}`}>
                  <Tooltip title="Editar Direccion de Facturación">
                    <IconButton>
                      <EditIcon color="primary" />
                    </IconButton>
                  </Tooltip>
                </Link>
              ),
            }}
            localization={{
              body: {
                emptyDataSourceMessage: "No hay direcciónes que mostrar",
              },
              toolbar: { searchPlaceholder: "Buscar" },
              header: { actions: "Opciones" },
              pagination: { labelDisplayedRows: "{from} - {to} de {count}" },
            }}
          />
        </Grid>
      </Hidden>
    </LayoutDashboard>
  );
};

export default Index;
